import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'members-communications',
  standalone: true,
  templateUrl: './member-communications.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberCommunicationsComponent {}
